export default function MessageSection() {
  return (
    <section className="py-32 px-6 relative">
      {/* 背景装飾 */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="w-[900px] h-[900px] bg-gradient-radial from-[#F0EBF5]/30 to-transparent rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10">
        <h2 className="text-6xl font-bold text-[#2C2C2C] mb-12 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
          描く場所は、
          <br />
          選ばなくていい。
        </h2>

        <p className="text-2xl text-[#6B6B6B] font-light leading-relaxed">
          姿勢と角度があれば、
          <br />
          そこはもうアトリエです。
        </p>
      </div>
    </section>
  );
}
